import {Injectable} from '@angular/core';
import {Response, RequestOptionsArgs, Headers, Http, Connection, RequestOptions,BrowserXhr} from '@angular/http';
import { PageNavigationService } from '../../shared/services/page-navigation.service';
import { PopupService } from '../services/pop-up.service';

@Injectable()
export class ErrorService {

	vBackEndErrorCode: {
        //'801': string,
        //'802': string,
        //'803': string,
        //'804': string,
        '805': string,
        //'806': string
		'807': string,
        //'808': string,
        '809': string,
        '810': string,
        '811': string,
        '812': string,
        //'813': string,
        //'814': string,
        //'815': string,
        '816': string,
        '817': string,
        '902': string,
        '905': string,
        '906': string,
        '907': string,
        '908': string,
        '909': string,
        '910': string,
        //'51001': string,
        //'51008': string,
        //'51010': string,
        '51015': string,
        '51016': string,
        '90002': string
	}; //define all error codes from backend here
    vErrorFlag: boolean;
    vBackEndPopupErrorCode:{
        '825': string
        "62001": string,
        "62002": string,
        "62003": string,
        "62004": string,
        "62005": string,
        "53504" : string,
        "53505" : string,
        // "90001": string
    }
	vError: {
		field1: {status: boolean, message: string},
		field2: {status: boolean, message: string},
		field3: {status: boolean, message: string},
		field4: {status: boolean, message: string},
		field5: {status: boolean, message: string},
		field6: {status: boolean, message: string},
		field7: {status: boolean, message: string},
		field8: {status: boolean, message: string},
		field9: {status: boolean, message: string},
		field10: {status: boolean, message: string},
		field11: {status: boolean, message: string},
        field12: {status: boolean, message: string},
        field13: {status: boolean, message: string}, 
        field14: {status: boolean, message: string},
        field15: {status: boolean, message: string},
        field16: {status: boolean, message: string},
        field17: {status: boolean, message: string},
        field18: {status: boolean, message: string},
        field19: {status: boolean, message: string},
        field20: {status: boolean, message: string},
        field21: {status: boolean, message: string}
        
	}; //define the field, reset and reuse this variable to show error messages

	vBackEndError: {status: boolean, code: string, message: string};

	constructor(
        private _http: Http,
        private _pageNavigationService: PageNavigationService,
        private _popupService: PopupService
    ) {
        this.defineBackEndErrorCodeAndMessage();
        this.defineBackEndErrorPopupCodeAndMessage();
        this.vErrorFlag = false;

    }

    defineBackEndErrorCodeAndMessage() {
    	this.vBackEndErrorCode = {
            //'801': 'Register failed', //in register, network error
            //'802': 'Update id failed', //in register, network error
            //'803': 'Add to group failed', //in register, approve, create => network error
    		//'804': 'Remove from group failed', //in approveuser => network error
            '805': 'Confirm registration failed, please try again', //in registration confirmation => default if error not 904 (email already used) and 905 (code mismatch)
            //'806': 'Show list users unauthorized error', //in list user unauthorized => network error
            '807': 'Login failed', // in login => network error
            //'808': 'Renew token failed', 
            '809': 'Unable to resend code, please try again', //in registration confirmation => network error, (email false)
            //'810': 'The change password has failed.', //in update profile => default if error not 906 'in update profile, change password'
            '810': 'The new password format is invalid.',
            '811': 'Unable to send code to your email', //forget password => network error, (email false *unlikely)
            '812': 'The new password format is invalid.', //confirm forget password => network error, (wrong email *unlikely), default error if not 905(code mismatch)
            //'813': 'Logout failed', // in logout => not really needed to display
            //'814': 'Create account failed', //in admin create account => network error, email exists
            //'815': 'Unable to send the email', //in admin create account => network error, 
            '816': 'Change password failed, please try again', // in forcechangepassword => temporary password failed, network error
            '817': 'Change password failed, please try again', // in forcechangepassword => (wrong email), network error
            //'902': 'Incorrect email or password', //in login Commented by Anjaiah
            '902': 'The email address and/or password entered are invalid.', //in login 
            '905': 'The verification code you have entered is incorrect. Please try again.', //in registration confirm and forget pass
            '906': 'Incorrect old password', //Incorrect old password in forcechangepassword
            //'907': 'Incorrect email or password', // Commented by Anjaiah
            '907': 'Your email address or password is incorrect.',
            '908': 'Attempt limit exceeded, please try again after some time',
            "909": 'Code has been expired, please request a code again',
            "910": 'Send code failed, please try again',
            //'51001': 'Token Invalid',
            //'51008': 'Your account has not been approved by Singtel Admin, please wait',
            //'51010': 'Your user account is still logged in',
            '51015': 'The security answer provided does not match with our record.', //in forgotpassword -> wrong sec answer, network error, also in change sec, but by popup.
            '51016': 'The email address provided is invalid.', // in forgotpassword => wrong email, network error.
            '90002' : 'Sorry, we are performing system upgrade. Please refresh this page [F5]'
    	};
    }

    defineBackEndErrorPopupCodeAndMessage() {
        this.vBackEndPopupErrorCode = {
            '825': 'Failed to send email',
            '62001': "Coordinates is outside Singapore",
            '62002': "Failure",
            '62003': "Plot not received",
            '62004': "Plot started",
            '62005': "Legend not valid",
            "53504": 'The plan map used for this NCE application has already been used for another NCE application',
            "53505": "You've Reached Daily Plant Map Purchase Limit",
            // '90001': "Timeout",
        }
    }

    resetError() {
    	this.vError = {
    		field1: {status: false, message: ''},
    		field2: {status: false, message: ''},
    		field3: {status: false, message: ''},
    		field4: {status: false, message: ''},
    		field5: {status: false, message: ''},
            field6: {status: false, message: ''},
            field7: {status: false, message: ''},
            field8: {status: false, message: ''},
            field9: {status: false, message: ''},
            field10: {status: false, message: ''},
            field11: {status: false, message: ''},
            field12: {status: false, message: ''},
            field13: {status: false, message: ''},
            field14: {status: false, message: ''},
            field15: {status: false, message: ''},
            field16: {status: false, message: ''},
            field17: {status: false, message: ''},
            field18: {status: false, message: ''},
            field19: {status: false, message: ''},
            field20: {status: false, message: ''},
            field21: {status: false, message: ''}
    	}
    }

    resetErrorFlag() {
        this.vErrorFlag = false;
    }

    getErrorFlag() {
        return this.vErrorFlag;
    }

    setErrorFlag(pFlag: boolean) {
        this.vErrorFlag = pFlag;
    }

    getErrorStatusAndMessage() {
        return this.vError;
    }

    setErrorStatusAndMessage(pFieldName: string, pErrorMessage: string) {
    	//set vError here based on field name, then define the error message. below are the example
        if(pFieldName == 'email'){
            this.vError.field1.status = true;
            this.vError.field1.message = pErrorMessage;
        } else if(pFieldName == 'retypeEmail'){
            this.vError.field2.status = true;
            this.vError.field2.message = pErrorMessage;
        } else if(pFieldName == 'password'){
            this.vError.field3.status = true;
            this.vError.field3.message = pErrorMessage;
        } else if(pFieldName == 'retypePassword'){
            this.vError.field4.status = true;
            this.vError.field4.message = pErrorMessage;
        } else if(pFieldName == 'phoneNo'){
            this.vError.field5.status = true;
            this.vError.field5.message = pErrorMessage;
        } else if(pFieldName == 'postalCode'){
            this.vError.field6.status = true;
            this.vError.field6.message = pErrorMessage;
        } else if(pFieldName == 'supervisorTel'){
            this.vError.field7.status = true;
            this.vError.field7.message = pErrorMessage;
        } else if(pFieldName == 'supervisorMobile'){
            this.vError.field8.status = true;
            this.vError.field8.message = pErrorMessage;
        } else if(pFieldName == 'contractTel'){
            this.vError.field9.status = true;
            this.vError.field9.message = pErrorMessage;
        } else if(pFieldName == 'contractMobile'){
            this.vError.field10.status = true;
            this.vError.field10.message = pErrorMessage;
        } else if(pFieldName == 'tcdwTel'){
            this.vError.field11.status = true;
            this.vError.field11.message = pErrorMessage;
        } else if(pFieldName == 'tcdwMobile'){
            this.vError.field12.status = true;
            this.vError.field12.message = pErrorMessage;
        } else if(pFieldName == 'pipeAffected'){
            this.vError.field1.status = true;
            this.vError.field1.message = pErrorMessage;
        } else if(pFieldName == 'distanceArea'){
            this.vError.field2.status = true;
            this.vError.field2.message = pErrorMessage;
        } else if(pFieldName == 'depthEarthwork'){
            this.vError.field3.status = true;
            this.vError.field3.message = pErrorMessage;
        } else if(pFieldName == 'plantRequestID'){
            this.vError.field6.status = true;
            this.vError.field6.message = pErrorMessage;
        } else if(pFieldName == 'NCERequestID'){
            this.vError.field6.status = true;
            this.vError.field6.message = pErrorMessage;
        } else if(pFieldName == 'contractorPhone'){
            this.vError.field13.status = true;
            this.vError.field13.message = pErrorMessage;
        } else if(pFieldName == 'plantMapPin'){
            this.vError.field14.status = true;
            this.vError.field14.message = pErrorMessage;
        } else if(pFieldName == 'plantRequestIDExt'){
            this.vError.field16.status = true;
            this.vError.field16.message = pErrorMessage;
        } else if(pFieldName == 'manholeNumber'){
            this.vError.field15.status = true;
            this.vError.field15.message = pErrorMessage;
        } else if(pFieldName == 'spvNric'){
            this.vError.field17.status = true;
            this.vError.field17.message = pErrorMessage;
        } else if(pFieldName == 'tcdwNric'){
            this.vError.field18.status = true;
            this.vError.field18.message = pErrorMessage;
        }else if(pFieldName == 'Earthwork'){
            this.vError.field19.status = true;
            this.vError.field19.message = pErrorMessage;
        }
	 /*Priya*/
        else if(pFieldName == 'securityquestion'){
            this.vError.field7.status = true;
            this.vError.field7.message = pErrorMessage;
        }
        else if(pFieldName == 'securityanswer'){
            this.vError.field9.status = true;
            this.vError.field9.message = pErrorMessage;
        }
        else if(pFieldName == 'designation'){
            this.vError.field10.status = true;
            this.vError.field10.message = pErrorMessage;
        }
         /*Priya*/

        //Kowsalya
        else if(pFieldName == 'companyreg'){
            this.vError.field20.status = true;
            this.vError.field20.message = pErrorMessage;
        }
        else if(pFieldName == 'licence'){
            this.vError.field21.status = true;
            this.vError.field21.message = pErrorMessage;
        }
        //Kowsalya
    }

    resetBackEndError() {
        this.vBackEndError = {
            status: false,
            code: "000",
            message: ""
        }
    }

    getBackEndError() {
        return this.vBackEndError;
    }

    setBackEndError(pCode: any, pDesc: any) {
        if(pCode === 0){
            this.openNetworkErrorPopup();
            return;
        }
        let msg = this.vBackEndErrorCode[pCode];
        if(msg === undefined){
            msg = this.vBackEndPopupErrorCode[pCode];
            if(msg !== undefined) {
                this._popupService.openGeneralConfirmationPopup('Error', msg, '', false, false);
            } else {
                this.openErrorPopup();
            }
            return;
        }else{
            if(pCode == '90002'){
                this._pageNavigationService.navigate(['maintenance']);
                this.openMaintenancePopup();
            }else{
                this.vBackEndError = {
                    status: true,
                    code: pCode,
                    message: msg
                }
            }
        }        
    }

    openMaintenancePopup(){
        this._popupService.closePopup();
        this._popupService.openPopup( 'confirmation', {
            title: 'Notice',
            message: 
            'Sorry, we are performing system upgrade. Please get back to us later',
            buttons: {
                CANCEL: {
                    text: 'Close',
                    function: () => {
                        this._popupService.closePopup();
                    }
                }
            }}
        );
    }

    openErrorPopup(){
        this._popupService.closePopup();
        this._popupService.openPopup( 'confirmation', {
            title: 'Notice',
            message: 'Sorry, something went wrong',
            buttons: {
                CANCEL: {
                    text: 'Close',
                    function: () => {
                        this._popupService.closePopup();
                    }
                }
            }}
        );
    }

    openNetworkErrorPopup(){
        this._popupService.closePopup();
        this._popupService.openPopup( 'confirmation', {
            title: 'Notice',
            message: 'Connection problem. Please check your connection and try again later.',
            buttons: {
                CANCEL: {
                    text: 'Close',
                    function: () => {
                        this._popupService.closePopup();
                    }
                }
            }}
        );
    }

    checkErrorStatus(pStatus) {

         if(pStatus == 'NetworkingError') {
             this.vBackEndError = {
                 status: true,
                 code: '123',
                 message: 'Connection problem. Please try again later.',
             };
         }
    }
}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/shared/services/error.service.ts